<div class="row mt-3">
    <div class="col-lg-12 mb-2">
        <h5>Welcome to Home</h5>
    </div>
    <div class="col-lg-12">
      <div class="white-bg">
        <h1>Welcome to Contractor Management!</h1>
      </div>
    </div>
</div>